import React, { useEffect } from 'react';
import './Record.css';
import '../App.css';
import Carousel from './Carousel.js';

function Record() {

    // useEffect(() => {
    //     const video = document.getElementById('background-video');
    
    //     // Adjust the video settings as needed
    //     video.setAttribute('autoplay', true);
    //     video.setAttribute('loop', true);
    //     video.setAttribute('muted', true);
    //   }, []);


  return (
    <div className='record-container'>
        {/* <video id="background-video" className="video-background" autoPlay loop muted>
        <source src="./videos/video-1.mp4" type="video/mp4" />
        </video> */}
        
        <div className='record-header'>
            <p>See My Record Transactions</p>
        </div>
        <div className='record-body'>
            <Carousel timer={9000} infinite
            recordsList={["Queenstown EA sold record of $1.26M in 3 weeks with a COV of $100k!", 
            "Newly MOP Sembawang flat sold at $582k in 5 days!", 
            "5 room flat in Redhill rented out at record $5700 in 1 week, highest rental in the block!",
            "EM at Bukit Panjang sold at record $830k in 2 weeks!", 
            "Semi-D at Hillview rented out at record $9000 in 1 week, surpassing $6500 rent of neighbouring properties!", 
            "Successfully negotiated a significant increase of rent from $5200 to $7300 for corner terrace at Potong Pasir!",
            "Teban Garden 5 room flat rented out at record breaking rental $3500!",
            "Vintage EA flat in Choa Chu Kang North sold at noteworthy price of $713k!",
            "Original and vintage 4-room HDB flat in Ang Mo Kio set a new record, fetching an impressive $500,000 in just 3 days!",
            "Rented out a One + Study apartment at Guillemard Road for a remarkable $3000!",
            "Two-bedroom condominium apartment at Twin Vew rented out for $4250 monthly, an increase in rent of $1050!",
            "Helped my buyers swiftly secure a spacious 4-room HDB next to the MRT and Hillion Mall, negotiated $15k in savings for my happy client!",
            "46-year-old, 3-room HDB flat sold in just 2 days for a record-breaking $438k— $28k above the last transacted price!",
            "Esta Ruby 3-bedroom apartment sold in just 3 weeks for an impressive $2M. An astonishing $300k above the last transacted price of $1.7M!",
            "Another unit in Esta Ruby sold shortly after my previous record-breaking sale—this time at an impressive $2.05M, surpassing my own record by $50K!",
            "Sold a compact 3-bedroom unit at Parc Botannia in 11 days — above prices of upper-floor units!",
            "Sold a 2+Study at Beacon Heights for $46K above the last transacted price for the same floor area!",
            "Successfully sold a 25-year-old condo at a strong price, enabling the seller to cash out comfortably for retirement.",
            "Rented out this 3-bedroom penthouse at The Florentine in just one weekend at an impressive price!",
            "5 Room flat at Bishan sold at $1.1M in 2 weeks!",
            "Trivilis 5BR sold at $1.38m in 2 weeks!",
            "Another Trivilis 4BR flat sold at $1m in 3 weeks!",
            "Sold this boutique at record price!"
        ]}
            >
                <img src='images/records/record-1.jpg' alt='record-img'/>
                <img src='images/records/record-2.jpg' alt='record-img'/>
                <img src='images/records/record-3.jpg' alt='record-img'/>
                <img src='images/records/record-4.jpg' alt='record-img'/>
                <img src='images/records/record-5.jpg' alt='record-img'/>
                <img src='images/records/record-6.jpg' alt='record-img'/>
                <img src='images/records/record-7.jpg' alt='record-img'/>
                <img src='images/records/record-8.jpg' alt='record-img'/>
                <img src='images/records/record-9.jpg' alt='record-img'/>
                <img src='images/records/record-10.jpg' alt='record-img'/>
                <img src='images/records/record-11.jpg' alt='record-img'/>
                <img src='images/records/record-12.png' alt='record-img'/>
                <img src='images/records/record-13.jpg' alt='record-img'/>
                <img src='images/records/record-14.png' alt='record-img'/>
                <img src='images/records/record-15.jpg' alt='record-img'/>
                <img src='images/records/parc_botannia.jpg' alt='record-img'/>
                <img src='images/records/beacon_height.jpg' alt='record-img'/>
                <img src='images/records/yuu_mei_green.jpg' alt='record-img'/>
                <img src='images/records/florentine.jpg' alt='record-img'/>
                <img src='images/records/Bishan-5Rm.jpeg' alt='record-img'/>
                <img src='images/records/Trivilis-5Rm.jpeg' alt='record-img'/>
                <img src='images/records/Trivilis-4Rm.jpeg' alt='record-img'/>
                <img src='images/records/record-16.jpeg' alt='record-img'/>
            </Carousel>
        </div>
    </div>
  )
}

export default Record